module.exports = __webpack_public_path__ + "img/performance.c3b7ed87.png";